import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import MainLayOut from "./component/MainLayOut";
import { useEffect } from "react";
import Home from "./pages/Home";
import ContactUs from "./pages/contact-us/ContactUs";
import Appointment from "./pages/home/Appointment";
import Gallery from "./pages/gallery/Gallery";
import Blog from "./pages/blog/Blog";
import About from "./pages/about/About";
import Services from "./pages/services/Services";
import Faq from "./pages/faq/Faq";
import AllServices from "./pages/services/Orthopedic";
import Physiotherapy from "./pages/services/Neurology";
import Gynecology from "./pages/services/GeneralMedicine";
import Orthopaedics from "./pages/services/GeneralSurgery";
import CoronavirusInfections from "./pages/blog/CoronavirusInfections";
import AboutCoronavirus from "./pages/blog/AboutCoronavirus";
import UrologyOrthopedics from "./pages/blog/UrologyOrthopedics";
import Team from "./pages/ourdoctor/OurDoctor";
import OurDoctor from "./pages/ourdoctor/OurDoctor";
import Gastroenterology from "./pages/services/Gastroenterology";
import GeneralMedicine from "./pages/services/GeneralMedicine";
import GeneralSurgery from "./pages/services/GeneralSurgery";
import Gynaecology from "./pages/services/Gynaecology";
import Neurology from "./pages/services/Neurology";
import Neurosurgery from "./pages/services/Neurosurgery";
import Orthopedic from "./pages/services/Orthopedic";
import Paediatrics from "./pages/services/Paediatrics";
import Neuropsychiatrist from "./pages/services/Neuropsychiatrist";
import Dental from "./pages/services/Dental";
import AmrendraVerma from "./pages/ourdoctor/AmrendraVerma";
import MulayamSinghYadav from "./pages/ourdoctor/MulayamSinghYadav";
import PopUp from "./pages/PopUp";
import Physiotherapist from "./pages/services/Physiotherapist";
import DrShrutiShandilya from "./pages/ourdoctor/DrShrutiShandilya";
import ENT from "./pages/services/ENT";
import DrRohitDubey from "./pages/ourdoctor/DrRohitDubey";
import DrDivyantGupta from "./pages/ourdoctor/DrDivyantGupta";
import DrRadheShyam from "./pages/ourdoctor/DrRadheShyam";
import DrVahguruSharanBathija from "./pages/ourdoctor/DrVahguruSharanBathija";
import VideoGallery from "./pages/gallery/VideoGallery";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
function App() {
  return (

    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" exact element={<MainLayOut />}>
          <Route index element={<Home />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/appointment" element={<Appointment />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/coronavirus-infections" element={<CoronavirusInfections />} />
          <Route path="/about-coronavirus" element={<AboutCoronavirus />} />
          <Route path="/urology-orthopedics" element={<UrologyOrthopedics />} />
          <Route path="/our-doctor" element={<OurDoctor />} />
          <Route path="/gastroenterology" element={<Gastroenterology />} />
          <Route path="/general-medicine" element={<GeneralMedicine />} />
          <Route path="/general-surgery" element={<GeneralSurgery />} />
          <Route path="/gynaecology" element={<Gynaecology />} />
          <Route path="/neurology" element={<Neurology />} />
          <Route path="/neurosurgery" element={<Neurosurgery />} />
          <Route path="/orthopedic" element={<Orthopedic />} />
          <Route path="/paediatrics" element={<Paediatrics />} />
          <Route path="/neuropsychiatrist" element={<Neuropsychiatrist />} />
          <Route path="/dental" element={<Dental />} />
          <Route path="/physiotherapist" element={<Physiotherapist />} />
          <Route path="/Dr-av" element={<AmrendraVerma />} />
          <Route path="/Dr-msy" element={<MulayamSinghYadav />} />
          <Route path="/dr-shruti-shandilya" element={<DrShrutiShandilya />} />
          <Route path="/ent" element={<ENT />} />
          <Route path="/dr-rohit-dubey" element={<DrRohitDubey />} />
          <Route path="/dr-divyant-gupta" element={<DrDivyantGupta />} />
          <Route path="/dr-radhe-shyam" element={<DrRadheShyam />} />
          <Route path="/dr-vahguru-sharan-bathija" element={<DrVahguruSharanBathija />} />
          <Route path="/video-gallery" element={<VideoGallery />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
